class GmAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.storageKey = `gm-announcement-dismissed-v2-${this.dataset.id}`;

    if (window.localStorage.getItem(this.storageKey)) {
      this.remove();
      return;
    }

    this.querySelector('.gm-announcement__close').addEventListener('click', () => this.dismiss());
  }

  dismiss() {
    window.localStorage.setItem(this.storageKey, '1');
    this.remove();
  }
}

customElements.define('gm-announcement-bar', GmAnnouncementBar);
